export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/flyer_design.827a244.svg";